import { render, staticRenderFns } from "./FrameworkEdit.vue?vue&type=template&id=36979bb2"
import script from "./FrameworkEdit.vue?vue&type=script&lang=js"
export * from "./FrameworkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports